import { getTeamOrPlayerImageUrl } from '~/domains/common/utils/getTeamOrPlayerImageUrl';

import type { PropPickProps } from '../../common/types/propPickProps.type';
import type { APIPropExpanded } from '../../services/interfaces/propsService/api';
import { isPublicGameWithTeams } from '../../services/interfaces/propsService/api/game';
import { getLeagueFormat } from '../../services/interfaces/propsService/api/leagues';

import { teamIdForLeagueImage } from './playerTeamId.utils';

type ImageProp = Pick<
  APIPropExpanded,
  'league' | 'entity_id' | 'use_team_image' | 'team_id' | 'team' | 'entity' | 'game'
>;

function getPlayerTeamIconUrl(prop: ImageProp): string | undefined {
  if (prop.team?.icon_url) return prop.team.icon_url;
  if (!prop.game || !isPublicGameWithTeams(prop.game)) return undefined;

  const teamId = teamIdForLeagueImage(prop);
  return [prop.game.away, prop.game.home].find((team) => team.id === teamId)?.icon_url;
}

export function getPlayerTeamLogoUrl(prop: ImageProp): string {
  return getTeamOrPlayerImageUrl(
    prop.league,
    teamIdForLeagueImage(prop),
    getPlayerTeamIconUrl(prop)
  );
}

export function getPropPlayerImageUrl(prop: ImageProp): string {
  if (!prop.use_team_image) return getTeamOrPlayerImageUrl(prop.league, prop.entity_id);

  return getTeamOrPlayerImageUrl(
    prop.league,
    teamIdForLeagueImage(prop) ?? prop.entity_id,
    getPlayerTeamIconUrl(prop)
  );
}

export function getPickTeamLogoUrl({
  league,
  playerTeamId,
  awayTeam,
  homeTeam,
}: Pick<PropPickProps, 'league' | 'playerTeamId' | 'awayTeam' | 'homeTeam'>): string | undefined {
  if (getLeagueFormat(league) !== 'team') return undefined;

  const playerTeam = [awayTeam, homeTeam].find((team) => !!team && team.id === playerTeamId);
  return getTeamOrPlayerImageUrl(
    league,
    playerTeamId?.length ? playerTeamId : undefined,
    playerTeam?.iconUrl
  );
}
